import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBranding } from "@/context/BrandingContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const { branding } = useBranding();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(username.trim(), password);
    setSubmitting(false);
    if (!res.ok) { toast.error(res.error); return; }
    if (res.user.role !== "admin") {
      toast.error("Este acesso é exclusivo para administradores.");
      return;
    }
    toast.success("Bem-vindo, administrador");
    nav("/admin");
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="back-to-req" className="inline-flex items-center gap-2 text-slate-400 hover:text-white text-sm mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar ao portal
        </Link>

        <div className="border border-slate-800 rounded-xl p-8 bg-slate-900">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-11 w-11 rounded-lg flex items-center justify-center bg-brand">
              <ShieldCheck className="h-5 w-5 text-white" />
            </div>
            <div>
              <div className="font-heading text-xl font-bold">Painel Administrativo</div>
              <div className="text-xs text-slate-400">{branding.company_name}</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="admin-user" className="text-slate-300">E-mail do administrador</Label>
              <Input
                id="admin-user"
                data-testid="admin-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin@empresa.com"
                className="bg-slate-950 border-slate-800 text-white placeholder:text-slate-600"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="admin-pass" className="text-slate-300">Senha</Label>
              <Input
                id="admin-pass"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-slate-950 border-slate-800 text-white placeholder:text-slate-600"
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit"
              disabled={submitting}
              className="w-full btn-brand rounded-full h-11"
            >
              {submitting ? "Entrando..." : "Acessar painel"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
